var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownBlackArrow = function SvgDownBlackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 8.75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 8.309q0 0 .003-.004.007-.004.015-.01l6.644-6.645A.602.602 0 1 0 13.78.8L7.546 7.033 1.325.813a.602.602 0 0 0-.851.851l6.645 6.645a.6.6 0 0 0 .851 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.41250000000000003,
    d: "M7.97 8.309q0 0 .003-.004.007-.004.015-.01l6.644-6.645A.602.602 0 1 0 13.78.8L7.546 7.033 1.325.813a.602.602 0 0 0-.851.851l6.645 6.645a.6.6 0 0 0 .851 0"
  })));
};
export default SvgDownBlackArrow;